<template>
    <div class="addCategoriesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular
                class="mt-auto"
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <div v-else class="row">
            <div class="col-md-7">
                <v-form 
                    ref="form" 
                    lazy-validation 
                    class="mt-5 col-sm-8 col-md-8"
                    >
                    <v-text-field
                        label="Categoría"
                        placeholder="Ingrese el nombre de la categoría"
                        color=secondary
                        required
                        v-model="formData.nombreCategoriaComercial"
                        readonly
                        disabled
                    ></v-text-field>
                   
                    <v-text-field
                        label="*Nombre"
                        placeholder="Ingrese el nombre de la subcategoría"
                        color=secondary
                        v-model="formData.nombre"
                        :counter="25"
                        :maxlength="25"
                        :rules="subcategoryRules"
                        required
                    ></v-text-field>
                    <v-text-field
                        label="*Descripción"
                        placeholder="Ingrese una descripción"
                        color=secondary
                        v-model="formData.descripcion"
                        :rules="descripcionyRules"
                        :counter="40"
                        :maxlength="40"
                        required
                    ></v-text-field>
                    <v-text-field
                        label="Modo"
                        placeholder="Ingrese el nombre de la categoría"
                        color=secondary
                        required
                        v-model="formData.nombreModo"
                        readonly
                        disabled
                    ></v-text-field>
                </v-form>
                <div class="img-btn">

                    <v-tooltip left>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                fab
                                fixed
                                bottom
                                right
                                dark
                                large
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                @click="submitForm"
                                >
                                <v-icon dark>mdi-content-save</v-icon>
                            </v-btn>

                        </template>

                        <span>Guardar Subcategoría</span>

                    </v-tooltip>  
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import  EventBus  from '@/utils/event_bus.js';
    import Swal from "sweetalert2";
    import { mapActions, mapGetters } from "vuex";
    import { 
        ACTION_POST_CREATE_SUBCATEGORIES_MARKETPLACE,
        ACTION_GET_CATEGORIES_ID_MARKETPLACE,
        GET_STATE_LOADING_MARKETPLACE,
        GET_CATEGORIES_ID_MARKETPLACE,
        ACTION_GET_MODE_MARKETPLACE,
        GET_MODO_MARKETPLACE,
        MARKETPLACE_M,
    } from "@/views/categories_marketplace/store/types/types.js";

    export default {
        name:"addCategoriesComponent",
        props: {
            category: {
                required: true
            },
        },
        
        data() {
            return {
                formData: { 
                    nombreCategoriaComercial:this.category.nombre,
                    idCategoriaComercial: this.category.idCategoriaComercial,
                    nombre: '',
                    descripcion: '',
                    nombreModo: this.category.modo,
                    modo: 1,    
                },
                subcategoryRules: [
                    v => !!v || "El nombre de la subcategoría es requerido",
                    v => (v && v.length <= 25) || "El nombre no puede tener más de 25 caracteres",
                ],
                descripcionyRules: [
                    v => !!v || "La descripcion de la subcategoría es requerido",
                    v => (v && v.length <= 40) || "La descripción no puede tener más de 40 caracteres",
                ],
                showErrorMessages: false
            };
        },

        async mounted() {
            // id del modo
            await this.getMode();
            const modos = await this.modes;
            this.formData.modo = modos[0].idModoCategoria;
            
            EventBus.$on('reload-update-categoriesMarketplace-sub', async ()  => {
                await this.getcategory(this.category.idCategoriaComercial);
                await this.updatecategory();
            });

            await this.getcategory(this.category.idCategoriaComercial);

        },

        methods: {

            ...mapActions({
                getMode: `${MARKETPLACE_M}${ACTION_GET_MODE_MARKETPLACE}`,
                putUpdateSubCategoria: `${MARKETPLACE_M}${ACTION_POST_CREATE_SUBCATEGORIES_MARKETPLACE}`,
                getcategory: `${MARKETPLACE_M}${ACTION_GET_CATEGORIES_ID_MARKETPLACE}`,
                
            }),

            updatecategory(){
                this.formData.nombreCategoriaComercial = this.categoryConsult.nombre
            },

            async submitForm() {
                // Validar el formulario antes de enviarlo
                const validationErrors = this.validateForm();

                // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                if (Object.keys(validationErrors).length > 0) {
                    const errorMessages = Object.values(validationErrors).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: 'Errores de validación',
                        html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                        confirmButtonColor: '#6E17A5'
                    });
                    return;
                }

                // Si no hay errores de validación, imprime el formulario en la consola
                const save = this.putUpdateSubCategoria(this.formData);
                if(!save){
                    return Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Debes diligenciar los campos'
                    })

                }
                
                await this.clearForm();

                EventBus.$emit('formSubMarketplace-submitted-successfully');
                

            },

            clearForm() {
                this.formData.nombre = '';
                this.formData.descripcion = '';
                
            },

            validateForm() {
                this.showErrorMessages = true;

                const errors = {};

                if (!this.formData.idCategoriaComercial) {
                    errors.categoriaBeneficio = 'Categoría';
                }

                if (!this.formData.nombre || !this.formData.nombre.trim()) {
                    errors.nombre = 'Nombre';
                }

                if (!this.formData.descripcion || !this.formData.descripcion.trim()) {
                    errors.descripcion = 'Descripción';
                }

                if (!this.formData.modo) {
                    errors.descripcion = 'Modo';
                }
                
                return errors;
            },

        },

        computed: {

            ...mapGetters({
                modes: `${MARKETPLACE_M}${GET_MODO_MARKETPLACE}`,
                loading: `${MARKETPLACE_M}${GET_STATE_LOADING_MARKETPLACE}`,
                categoryConsult: `${MARKETPLACE_M}${GET_CATEGORIES_ID_MARKETPLACE}`,
                
            }),

        },

    };

</script>


<style lang="css" scoped>

        input[type="file"] {
            left: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
            color:red !important;
        }
    /* Css input imagen*/

    .col-md-7 {
        display: flex;
        justify-content: center;
        align-items: center;
        gap:230px;
    }
    .row {
        display: flex;
        justify-content: center;
    }

    /*Resposive*/

    @media screen and (max-width: 768px) {
        .col-md-7 {
            gap:40px;
        }
    }
    @media screen and (max-width: 425px) {
        .col-md-7 {
            gap:10px;
        }
    }

</style>